import { ReactNode } from 'react'

import ContactAvatar from '~/booking/components/ContactAvatar/ContactAvatar'

export default function BookingFormWrapper({
  children,
  isLoading,
}: {
  children: ReactNode
  isLoading: boolean
}): React.ReactElement {
  return (
    <section className="flex-1 py-4 lg:py-8 pb-16 px-7 lg:px-8 md:flex md:flex-col xl:flex-row bg-gray-off-white m-auto">
      <form action="" className={`max-w-lg w-full space-y-6 ${isLoading ? 'animate-pulse' : 'opacity-100'}`}>
        {children}
      </form>
      <div className="hidden md:block">
        <ContactAvatar />
      </div>
    </section>
  )
}
